import { createContext, useContext } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useLastTrue } from './useLastTrue';

const PageKeyContext = createContext(null);

/**
 *
 * Return hooks that freeze result when page is not active (when hide animation in progress)
 */
export const usePageContext = () => {
	const location = useLocation();
	const key = useContext(PageKeyContext);

	const isActive = location.key === key;
	const useLastActive = value => useLastTrue(isActive, value);

	return {
		/**
		 * Same as react-router-dom useLocation, but
		 * **freeze** result value when page not active
		 *
		 */
		useLocation: () => useLastActive(location),

		/**
		 * Similar to react-router-dom useSearchParams, but
		 * **freeze** result value when page not active
		 *
		 */
		useSearchParams: () => {
			const [searchParams] = useSearchParams();
			return useLastActive(searchParams);
		},

		/**
		 * Same as redux useSelector, but
		 * **freeze** result value when page not active
		 *
		 */
		useSelector: (...args) => useLastActive(useSelector(...args)),

		/**
		 * **freeze** value when page not active
		 *
		 */
		useLastActive,
	};
};

export const PageKeyProvider = PageKeyContext.Provider;
